import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SolanaProvider from "./components/jetdog/SolanaProvider";
import SiteSfx from "./components/jetdog/SiteSfx";
import HomePage from "./pages/HomePage";
import PlayPage from "./pages/PlayPage";
import GamePreview from "./pages/GamePreview";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <SolanaProvider>
        <BrowserRouter>
          <SiteSfx />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/play" element={<PlayPage />} />
            <Route path="/_preview" element={<GamePreview />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </SolanaProvider>
    </div>
  );
}

export default App;
